import { Component, Input, OnInit } from '@angular/core';
import { PublicRecordModel } from '@cv-invision/cv.invision-views.ux';

@Component({
	selector: 'cv-ci-public-record-list',
	styleUrls: ['./ci-public-record-list.component.scss'],
	templateUrl: './ci-public-record-list.component.html'
})
export class CiPublicRecordListComponent implements OnInit {

	@Input() publicRecord: PublicRecordModel;

	public publicRecordAddress: any;
	public deeds: any[] = [];
	public copiedNotifyOpen = false;

	get address(): string {
		let txt = `${this.publicRecord.streetName} #${this.publicRecord.streetNumber}`;

		if (this.publicRecord.streetName === '' || this.publicRecord.streetName === null) {
			txt = this.publicRecord.unparsedAddress;
		}

		return txt;
	}

	ngOnInit(): void {
		this.setDeeds();
	}

	/**
	 * Event to store in navigator clipboard
	 *
	 * @param value
	 */
	copyToClipboard(value: string) {
		if (value) navigator.clipboard.writeText(value)
	}

	/**
	 * To display the small & quick toaster that informs the
	 * user that his value was successfully copied
	 *
	 * @param event
	 */
	copiedEvent(event: any): void {
		this.copiedNotifyOpen = true;
		setTimeout(() => {
			this.copiedNotifyOpen = false;
		}, 1000);
	}

	/**
	 * Add title & open attributes + Sort the Deeds
	 */
	setDeeds(): void {
		if (this.publicRecord) {
			this.deeds = [];
			if ('mortgageDeeds' in this.publicRecord) {
				this.deeds = this.deeds.concat([...(this.publicRecord.mortgageDeeds || []).map((deed: any) => {
					return { ...deed, title: 'MORTGAGE', open: false }
				})]);
			}

			if ('transferDeeds' in this.publicRecord) {
				this.deeds = this.deeds.concat([...(this.publicRecord.transferDeeds || []).map((deed: any) => {
					return { ...deed, title: 'TRANSFER', open: false }
				})]);
			}
		}

		this.sortDeeds();
	}

	/**
	 * Add title & open attributes + Sort the Deeds
	 */
	sortDeeds(): void {
		this.deeds.sort(function (a: any, b: any) {
			const dateA = new Date(a.recordingDate).getTime();
			const dateB = new Date(b.recordingDate).getTime();

			return dateA > dateB ? -1 : 1;
		});
	}

}
